import { AxiosPromise } from "axios";
import axios from "../../axios";

export type Events = {
	buttons: number,
	links: number,
	videos: number,
	hotspots: number,
	overlays: number
}

export type PublicationEvents = {
	pbid: number,
	name: string,
	first_published_on: string,
	status: string,
	pages: {
		pid: number,
		name: string,
		timeframe: {
			begin: string,
			end: string
		},
		events: Events
	}[]
};

export const getPublicationEventsById = (pbid: number): AxiosPromise => {
	return axios.get(`events/${pbid}`);
};